import {createFeatureSelector, createSelectorFactory, MemoizedProjection} from '@ngrx/store';
import { State } from './users.reducer';
import {AnyFn} from '@ngrx/store/src/selector';

export const getUsersFeature = createFeatureSelector<State>('users');

export function isEqual(a: any, b: any): boolean {
    return a.totalRows === b.totalRows &&
        a.users.every(fromA => b.users.includes(fromA));
}

export function customMemoize(t: AnyFn): MemoizedProjection {
    let lastResult: any = null;

    function memoized(): any {
        const result = t.apply(null, arguments);

        if (lastResult == null || !isEqual(result, lastResult)) {
            lastResult = result;
            return result;
        }
        return lastResult;
    }

    function reset() { lastResult = null; }

    return {
        clearResult(): void {
        }, setResult(result: any): void {
        }, memoized, reset};
}

export const getUsers = createSelectorFactory(customMemoize)(
    getUsersFeature,
    (state) => {
        return {
            users: state.users,
            totalRows: state.totalRows,
            currentLazyLoad: state.currentLazyLoad
        };
    }
);
